// types
import { Control } from 'react-hook-form';
import { RecurrencePattern } from './components/RecurrencePatternBuilder/RecurrencePatternBuilder.types';
import {
  ActivityResponse,
  AppointmentExceptionResponse,
  AppointmentType,
  PlanningEntityIdentifier,
  RecurrenceExceptionUpdateType,
  SchedulingLabel
} from 'generated/index';

export type BaseFormSectionProps = {
  appointment: AppointmentFormFieldData;
  control: Control<any>;
};

export type AppointmentFormFieldData = {
  id?: string;
  activity?: ActivityResponse | null;
  appointmentExceptions?: AppointmentExceptionResponse[];
  isCopyPasteAction?: boolean;
  appointmentType?: AppointmentType;
  notePublic?: string;
  noteInternal?: string;
  start?: string;
  originalOccurrenceStart?: string;
  isRecurring?: boolean;
  end?: string;
  recurrenceExceptionUpdateType?: RecurrenceExceptionUpdateType;
  recurrencePattern?: RecurrencePattern;
  allowedToEditRecurrenceRule?: boolean;
  planEntities: AppointmentFormFieldEntities;
  schedulingLabel?: SchedulingLabel;
  editAppointmentType?: AppointmentRecurrenceType | null;
};

export type AppointmentFormFieldEntities = {
  EMPLOYEE: AppointmentFormFieldEntity[];
  CLIENT: AppointmentFormFieldEntity[];
  WORKPLACE: AppointmentFormFieldEntity[];
  RESOURCE: AppointmentFormFieldEntity[];
};

export type AppointmentFormFieldEntity = PlanningEntityIdentifier & {
  label: string;
};

export enum AppointmentRecurrenceType {
  ONLY_THIS = 'ONLY_THIS',
  THIS_AND_ALL_SUBSEQUENT = 'THIS_AND_ALL_SUBSEQUENT'
}
